import { useCallback, useState } from 'react';
import mapConstants from 'app/shared/constants/MapConstants';

interface UseMapStateReturn {
  lat: number | null;
  lon: number | null;
  zoom: number | null;
  border: boolean | null;
  setBorder: (border: boolean | null) => void;
  updateMapData: (lat: number, lon: number, zoom: number) => void;
  setZoom: (zoom: number) => void;
}

export const useMapState = (initialBorder?: boolean): UseMapStateReturn => {
  const [border, setBorder] = useState<boolean | null>(initialBorder ?? null);
  const [lon, setLon] = useState<number | null>(null);
  const [lat, setLat] = useState<number | null>(null);
  const [zoom, setZoom] = useState<number | null>(null);

  const updateMapData = useCallback((newLat: number, newLon: number, newZoom: number) => {
    const latFormatted = Number(newLat.toFixed(mapConstants.LAT_LON_PRECISION));
    const lonFormatted = Number(newLon.toFixed(mapConstants.LAT_LON_PRECISION));
    const zoomFormatted = Number(newZoom);

    setLat(latFormatted);
    setLon(lonFormatted);
    setZoom(zoomFormatted);
  }, []);

  return {
    lat,
    lon,
    zoom,
    border,
    setBorder,
    updateMapData,
    setZoom,
  };
};
